import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { AuthService } from '@core/services/apis';
import { LocalStorageService } from '@core/services/common';
import { environment } from '@environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;
  timeoutClear!: any;
  enteredButton = false;
  isMatMenuOpen = false;
  fullName = '';
  roleName = '';

  constructor(
    private authService: AuthService,
    private localStorage: LocalStorageService,
    private deviceDetector: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.fullName = this.localStorage.getFullName();
    const getRoleNameInterval = setInterval(() => {
      this.roleName = this.localStorage.getRoleName();
      if (this.roleName) {
        clearInterval(getRoleNameInterval);
      }
    }, 200);
  }

  openMenu(menuTrigger: MatMenuTrigger): void {
    if (!menuTrigger.menuOpen) {
      this.enteredButton = true;
      menuTrigger.openMenu();
      clearTimeout(this.timeoutClear);
    }
  }

  onMenuClosed(menuTrigger: MatMenuTrigger): void {
    this.timeoutClear = setTimeout(() => {
      if (!this.enteredButton) {
        this.isMatMenuOpen = false;
        menuTrigger.closeMenu();
      } else {
        this.isMatMenuOpen = false;
      }
    }, 100);
  }

  enterSubMenu() {
    this.isMatMenuOpen = true;
  }

  buttonLeave(menuTrigger: MatMenuTrigger) {
    this.timeoutClear = setTimeout(() => {
      if (this.enteredButton && !this.isMatMenuOpen) {
        menuTrigger.closeMenu();
      }
      if (!this.isMatMenuOpen) {
        menuTrigger.closeMenu();
      } else {
        this.enteredButton = false;
      }
    }, 100);
  }

  navigateToPass() {
    const accessToken = this.localStorage.getAccessToken();
    const refreshToken = this.localStorage.getRefreshToken();
    const isRefreshTokenExpired = this.authService.isRefreshTokenExpired;

    if (!isRefreshTokenExpired) {
      this.authService.verifyRefreshToken(refreshToken ?? '').subscribe(data => {
        const { result } = data.result;
        if (result) {
          const url = environment.PASS_URL + `/account-information?accessToken=${accessToken}&refreshToken=${refreshToken}`;
          const isDesktop = this.deviceDetector.isDesktop();
          if (isDesktop) {
            window.open(url, '_blank');
          } else {
            location.href = url;
          }
        } else {
          this.authService.logout();
        }
      });
    } else {
      this.authService.logout();
    }
  }

  onLogout() {
    this.authService.logout(true, true);
  }
}
